<div class="group-view">
  @for (person of groupViewData().persons; track person.personId) {
    <mat-accordion>
      <mat-expansion-panel [expanded]="true" class="group-view__panel">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div class="group-view__header">
              <mat-icon>person</mat-icon>
              <div class="group-view__header-content">
                <div>
                  <strong class="group-view__header-name">{{ person.personName }}</strong>
                  <span class="group-view__header-id">({{ person.memberId }})</span>
                </div>
                <span class="group-view__header-date-of-birth">{{
                  person.dateOfBirth | dateOnly
                }}</span>
              </div>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        @for (insuranceType of person.insuranceTypes; track insuranceType.insuranceType) {
          <mat-expansion-panel [expanded]="true" class="group-view__insurance">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="group-view__insurance-header">
                  <mat-icon>{{ insuranceType.icon || 'description' }}</mat-icon>
                  <strong>{{ insuranceType.insuranceTypeName }}</strong>
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>

            @for (policy of insuranceType.policies; track policy.policyNumber) {
              <div class="group-view__policy">
                <div class="group-view__policy-header">
                  <div class="group-view__policy-header-info">
                    <span class="group-view__policy-number">{{ policy.policyNumber }}</span>
                    <span class="group-view__policy-name">{{ policy.policyHolder }}</span>
                  </div>
                </div>

                <div class="group-view__plans">
                  @for (plan of policy.plans; track plan.planNumber) {
                    <mat-expansion-panel [expanded]="allExpanded()" class="plan-detail">
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          <div class="plan-detail-description">
                            <div class="plan-detail-description-group">
                              <div class="group-view__row">
                                <span class="group-view__plans-dates">
                                  {{ plan.planStartYear }}
                                  <mat-icon>arrow_right_alt</mat-icon>
                                  {{ plan.planEndYear }}
                                </span>
                                <span class="plan-detail-description-label">
                                  {{ plan.planName || '-' }}
                                </span>
                              </div>
                              <span>{{ plan.coverArea }}</span>
                            </div>
                            <div class="plan-detail-description-info">
                              <mat-icon
                                [matTooltip]="plan.tooltip"
                                class="icon-border"
                                [class.active]="plan.hasActive"
                                [class.warning]="plan.hasWaiting && !plan.hasActive"
                              >
                                fiber_manual_record
                              </mat-icon>
                              <span class="text-overflow"
                                >{{ plan.items.length }} Item{{
                                  plan.items.length !== 1 ? 's' : ''
                                }}</span
                              >
                            </div>
                          </div>
                        </mat-panel-title>
                      </mat-expansion-panel-header>

                      <div class="group-view__items">
                        @for (item of plan.items; track item.censusLineId) {
                          <app-generic-card
                            [config]="item.cardConfig"
                            (actionClick)="actionClick.emit($event)"
                          >
                          </app-generic-card>
                        }
                      </div>
                    </mat-expansion-panel>
                  }
                </div>
              </div>
            }
          </mat-expansion-panel>
        }
      </mat-expansion-panel>
    </mat-accordion>
  }
</div>
